import HeaderContainer from './HeaderContainer.js';
export default HeaderContainer;
//# sourceMappingURL=index.js.map